import { isAdminRole } from './adminPermissions';

// QA-зона = отдельная роль `QA` ПЛЮС все, у кого уже есть админ-доступ (переиспользуем isAdminRole, а не
// дублируем список ролей). Как и в adminPermissions — НИКОГДА не хардкодить строки ролей в компонентах.
export function isQaRole(role: string | undefined): boolean {
  return role === 'QA' || isAdminRole(role);
}

// Страницы QA-зоны (ключ = id пункта меню в QaSidebar). Сегодня одна — но держим карту под будущие.
export const QA_PAGES = ['accounts'] as const;

export function canAccessQaPage(role: string | undefined, pageId: string): boolean {
  return (QA_PAGES as readonly string[]).includes(pageId) && isQaRole(role);
}
